import { render, staticRenderFns } from "./PublicityDetail.vue?vue&type=template&id=54b6b763&scoped=true"
import script from "./PublicityDetail.vue?vue&type=script&lang=js"
export * from "./PublicityDetail.vue?vue&type=script&lang=js"
import style0 from "./PublicityDetail.vue?vue&type=style&index=0&id=54b6b763&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b6b763",
  null
  
)

export default component.exports